import React from 'react';
import { TourDetailPage } from '../components/TourDetailPage';
import { worldwideTours } from '../data/tours';

export const BhutanTourPage = () => {
  const tour = worldwideTours.find(t => t.id === 'bhutan-festival-journey');
  return <TourDetailPage tour={tour} />;
};
